/**
 * isartau — Variantenmitnahme beim Wechsel ueber eine Rubik-Reihe
 * ---------------------------------------------------------------------------
 * Problem: Die App "Rubik Combined Listings" verbindet eigenstaendige Produkte
 * zu Umschalter-Reihen. Wechselt der Kunde ueber so eine Reihe das Produkt,
 * geht seine Auswahl der ECHTEN Shopify-Optionen (z. B. "Beschlaege: silber")
 * verloren — das Zielprodukt startet auf seiner Standardvariante.
 *
 * Warum der Klick nicht abgefangen wird: Rubik rendert keine <a href>-Links,
 * sondern navigiert per JavaScript. Das Ereignis "rcl_swatch_clicked" feuert
 * am WINDOW (im Browser verifiziert, nicht am document!) und ist
 * cancelable = false — Rubik navigiert in JEDEM Fall. Ein Umleiten auf der
 * Quellseite ist damit ausgeschlossen.
 *
 * Deshalb zweistufig:
 *   Quellseite — beim Swatch-Klick SYNCHRON einen Merkzettel in sessionStorage
 *                schreiben (Zielpfad + Optionsname/-wert-Paare). Kein fetch,
 *                kein await davor, sonst navigiert Rubik vorher.
 *   Zielseite  — Merkzettel lesen, pruefen, passende Zielvariante bestimmen,
 *                Auswahl anwenden, Merkzettel loeschen.
 *
 * Es werden NIEMALS Varianten-IDs uebertragen, nur Optionsnamen und -werte.
 * Die Zielseite loest selbst auf. Damit koennen Quell- und Zielprodukt
 * unterschiedliche Optionsreihenfolgen haben, und Mass-Freitextfelder
 * (Line Item Properties) werden bewusst NICHT mitgenommen.
 *
 * Eingebunden ueber snippets/isartau-variantenmitnahme.liquid, aufgerufen aus
 * einem custom_liquid-Block in templates/product.json. Keine Dawn-Datei
 * veraendert.
 */
(function () {
  'use strict';

  /* =========================================================================
   * Schalter
   * ======================================================================= */

  /**
   * Betriebsart. Umschaltbar durch Aendern dieses einen Wortes.
   *
   *   'auswahl'   — REGULAERER WEG. Setzt die Auswahl direkt im DOM und laesst
   *                 Dawns eigene Logik nachziehen. Kein zusaetzlicher
   *                 Ladevorgang.
   *   'umleitung' — location.replace(pfad + '?variant=<id>').
   *
   * ACHTUNG, damit das spaeter niemand falsch einschaetzt: 'umleitung' ist
   * NICHT die schoenere Variante. Sie vermeidet das kurze Aufblitzen der
   * Standardvariante gerade NICHT — die Zielvariante steht erst nach dem
   * Abruf von /products/<handle>.js fest, und bis dahin ist die Seite laengst
   * gerendert. Der Modus behaelt also nur den Nachteil des zweiten
   * Ladevorgangs. Er bleibt aus zwei Gruenden implementiert:
   *   1. als automatischer Ausweichpfad, wenn data-product-url gefuellt ist
   *      (siehe pruefeProduktwechselFalle weiter unten),
   *   2. als manuell umschaltbare Reserve, falls sich der Auswahlpfad im
   *      Livebetrieb als unbrauchbar erweist.
   */
  var MODUS = 'auswahl';

  /** Konsolenausgaben. Im Normalbetrieb aus. */
  var DEBUG = false;

  /** sessionStorage-Schluessel. Praefix "isartau:" ist reserviert und frei —
   *  das Theme nutzt keinerlei Storage, Rubik nur "rcl_scroll_restore". */
  var SCHLUESSEL = 'isartau:variantenmitnahme';

  /** Hoechstalter des Merkzettels. Aelter = verwaist, wird verworfen. */
  var MAX_ALTER_MS = 30000;

  /* =========================================================================
   * Kleinkram
   * ======================================================================= */

  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[variantenmitnahme]');
    console.log.apply(console, args);
  }

  /**
   * Normalisierung fuer Optionsnamen UND Optionswerte: trimmen und
   * Gross-/Kleinschreibung ignorieren. Bewusst nicht mehr — es soll nur
   * Schreibweise ausgeglichen werden, keine Werte zusammenfallen lassen.
   */
  function norm(wert) {
    return String(wert == null ? '' : wert)
      .trim()
      .toLowerCase();
  }

  /** Pfade vergleichbar machen (abschliessender Schraegstrich egal). */
  function normPfad(pfad) {
    var p = String(pfad == null ? '' : pfad).trim();
    if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    return p;
  }

  /** Sieht der Pfad nach einer Produktseite aus? (auch mit Sprachpraefix) */
  function istProduktpfad(pfad) {
    return /\/products\/[^/]+$/.test(normPfad(pfad));
  }

  /**
   * Optionsnamen aus der Produkt-JSON.
   * Der Endpunkt /products/<handle>.js liefert `options` je nach API-Stand
   * entweder als Liste von Strings oder als Liste von Objekten mit `name`.
   * Beides wird bedient, damit ein Shopify-seitiger Formatwechsel das Skript
   * nicht still ausschaltet.
   */
  function optionsNamen(produkt) {
    var roh = (produkt && produkt.options) || [];
    return roh.map(function (o) {
      if (typeof o === 'string') return o;
      return (o && o.name) || '';
    });
  }

  /**
   * Alle im Produkt tatsaechlich vorkommenden Werte einer Optionsebene.
   * Aus den Varianten abgeleitet statt aus options[].values — die Varianten
   * sind die verlaessliche Quelle und in beiden API-Formaten gleich aufgebaut.
   */
  function werteDerOption(produkt, index) {
    var gesehen = {};
    var werte = [];
    (produkt.variants || []).forEach(function (v) {
      var w = v.options && v.options[index];
      if (w == null) return;
      var k = norm(w);
      if (gesehen[k]) return;
      gesehen[k] = true;
      werte.push(w);
    });
    return werte;
  }

  /* =========================================================================
   * Produktdaten
   * ======================================================================= */

  /**
   * Produkt-JSON der AKTUELLEN Seite. Bewusst ueber den .js-Endpunkt und nicht
   * durch Auslesen des Markups: markupunabhaengig, und wir bekommen die
   * vollstaendige Variantenliste, die im DOM nirgends steht (dort liegt nur
   * <script data-selected-variant> mit der EINEN aktuellen Variante).
   *
   * Wird nur im Arbeitsspeicher gehalten, nie in Storage.
   */
  var produktDaten = null;

  function ladeProdukt() {
    var pfad = normPfad(window.location.pathname);
    if (!istProduktpfad(pfad)) return Promise.resolve(null);

    return fetch(pfad + '.js')
      .then(function (antwort) {
        if (!antwort.ok) return null;
        return antwort.json();
      })
      .then(function (daten) {
        if (!daten || !daten.variants || !daten.variants.length) return null;
        produktDaten = daten;
        log('Produkt geladen', daten.handle, daten.variants.length + ' Varianten');
        return daten;
      })
      .catch(function (fehler) {
        log('Produktabruf fehlgeschlagen', fehler);
        return null;
      });
  }

  /* =========================================================================
   * DOM-Zugriffe
   * ======================================================================= */

  /**
   * Das versteckte Feld mit der aktuell gewaehlten Varianten-ID.
   *
   * Auf der Produktseite gibt es ZWEI input[name="id"]:
   *   1. Warenkorbformular   — snippets/buy-buttons.liquid, Zeilen 46-57,
   *                            traegt zusaetzlich class="product-variant-id"
   *   2. Ratenzahlungsformular — sections/main-product.liquid, Zeile 186,
   *                            ohne Klasse
   * Beide tragen denselben Wert und werden von Dawn gemeinsam nachgezogen
   * (assets/product-info.js, Zeilen 230-238). Wir wollen gezielt das erste.
   *
   * Die Klasse allein reicht nicht: dasselbe Markup steckt auch im
   * Quick-Add-Kaertchen (snippets/card-product.liquid, Zeile 354). Das rendert
   * auf der Produktseite heute nicht, haengt aber an einer Section-Einstellung
   * und nicht am Code. Deshalb zusaetzlich auf <product-info> verankert.
   */
  function variantenIdFeld() {
    return document.querySelector('product-info input[name="id"].product-variant-id');
  }

  function aktuelleVariantenId() {
    var feld = variantenIdFeld();
    if (!feld) return null;
    var wert = String(feld.value || '').trim();
    return wert || null;
  }

  function variantenAuswahl() {
    return document.querySelector('product-info variant-selects');
  }

  /**
   * Alle Optionsfelder der Variantenauswahl.
   *
   * Beide Darstellungen des Themes erzeugen dasselbe Grundelement:
   *   Textkapsel — snippets/product-variant-options.liquid, Zeilen 96-108
   *   Swatch     — snippets/swatch-input.liquid, Zeilen 30-46
   * Unterschiedlich sind nur Klassen und Beschriftung; `type="radio"`,
   * `value` und `data-option-name` sind identisch. Der isartau-Fallback
   * "Custom Swatches" entscheidet je Option neu, welche der beiden greift —
   * beide koennen also auf derselben Seite nebeneinander stehen
   * (Standard heute: "Beschlaege" als Swatch, alles andere als Textkapsel).
   */
  function optionsFelder(auswahl) {
    return Array.prototype.slice.call(
      auswahl.querySelectorAll('input[type="radio"][data-option-name]')
    );
  }

  /**
   * Passendes Optionsfeld suchen.
   *
   * Bewusst per Durchlauf und normalisiertem Vergleich statt ueber einen
   * CSS-Attributselektor: Optionsnamen wie
   * "Gewicht Hund (=Materialstaerke+Karabinergroesse)" enthalten Klammern,
   * "=" und "+". Ein zusammengebauter Selektor waere dort fehleranfaellig,
   * und ueber CSS.escape laesst sich zwar quoten, aber die Schreibweise
   * muesste weiterhin zeichengenau stimmen. Der Durchlauf ist unempfindlich
   * gegen beides.
   */
  function findeFeld(felder, optionsName, wert) {
    var nName = norm(optionsName);
    var nWert = norm(wert);
    for (var i = 0; i < felder.length; i++) {
      var f = felder[i];
      if (norm(f.dataset.optionName) !== nName) continue;
      if (norm(f.value) !== nWert) continue;
      return f;
    }
    return null;
  }

  /* =========================================================================
   * Merkzettel
   * ======================================================================= */

  function zettelSchreiben(zettel) {
    try {
      window.sessionStorage.setItem(SCHLUESSEL, JSON.stringify(zettel));
      return true;
    } catch (fehler) {
      log('Merkzettel konnte nicht geschrieben werden', fehler);
      return false;
    }
  }

  /**
   * Merkzettel lesen und im selben Zug loeschen — einmalige Verwendung,
   * auch bei anschliessendem Abbruch. Verhindert, dass ein alter Zettel bei
   * einem spaeteren, regulaeren Seitenaufruf noch etwas umstellt.
   */
  function zettelLesenUndVerwerfen() {
    var roh = null;
    try {
      roh = window.sessionStorage.getItem(SCHLUESSEL);
      window.sessionStorage.removeItem(SCHLUESSEL);
    } catch (fehler) {
      log('Merkzettel konnte nicht gelesen werden', fehler);
      return null;
    }
    if (!roh) return null;
    try {
      var zettel = JSON.parse(roh);
      if (!zettel || !Array.isArray(zettel.optionen) || !zettel.optionen.length) return null;
      return zettel;
    } catch (fehler) {
      log('Merkzettel unlesbar', fehler);
      return null;
    }
  }

  /* =========================================================================
   * Quellseite — Merkzettel schreiben
   * ======================================================================= */

  /**
   * Doppelausfuehrungs-Sperre. Zwei Faelle sind denkbar:
   *
   *   1. Rubik feuert das Ereignis am document MIT bubbles: true. Dann laeuft
   *      dasselbe Event-Objekt auch durch den window-Listener. Faengt die
   *      Identitaetspruefung ueber das WeakSet ab.
   *   2. Rubik feuert in einer kuenftigen Version ZWEI eigene Ereignisse
   *      (window und document). Dann sind es verschiedene Objekte — dafuer
   *      das kurze Zeitfenster auf denselben Zielpfad.
   *
   * Ein doppelt geschriebener Merkzettel waere inhaltlich harmlos (gleicher
   * Inhalt), die Sperre haelt das Verhalten aber eindeutig.
   */
  var behandelteEreignisse = new WeakSet();
  var letzterKlick = null;

  /**
   * Handler fuer "rcl_swatch_clicked" (Rubik Combined Listings).
   *
   * Alles hier laeuft SYNCHRON. Kein fetch, kein await: Das Ereignis ist
   * cancelable = false, Rubik navigiert unmittelbar danach. Was hier nicht
   * geschrieben ist, ist verloren.
   *
   * ZIEL DES LISTENERS: Rubik feuert am **window**, nicht am document. Das ist
   * im Browser verifiziert (Konsolenmitschnitt: "rcl_swatch_clicked @ window").
   * Ein Listener am document wird NIE ausgeloest — genau daran ist die erste
   * Fassung dieses Skripts still gescheitert. Registriert wird trotzdem an
   * beiden Orten, falls ein App-Update das Ereignis zusaetzlich oder
   * stattdessen am document feuert; die Sperre oben verhindert dann die
   * Doppelausfuehrung.
   *
   * Bewusst NICHT an einem Element im Produktbereich: Dawn ersetzt bei
   * Variantenwechseln Teile des DOM (unter anderem das komplette
   * <variant-selects>), Listener darin waeren danach tot.
   */
  function beiSwatchKlick(ereignis) {
    try {
      var detail = ereignis && ereignis.detail;
      if (!detail) return;

      // Fall 1 der Sperre: dasselbe Event-Objekt ein zweites Mal.
      if (ereignis && typeof ereignis === 'object') {
        if (behandelteEreignisse.has(ereignis)) return;
        behandelteEreignisse.add(ereignis);
      }

      // Klick auf den bereits aktiven Swatch: Rubik navigiert nicht, es gibt
      // nichts mitzunehmen.
      if (detail.isCurrent) return;

      var zielPfad = normPfad(detail.productUrl);
      if (!zielPfad || zielPfad.charAt(0) !== '/') return;
      if (!istProduktpfad(zielPfad)) return;

      // Fall 2 der Sperre: zwei eigenstaendige Ereignisse fuer denselben Klick.
      var jetzt = Date.now();
      if (letzterKlick && letzterKlick.pfad === zielPfad && jetzt - letzterKlick.zeit < 500) return;
      letzterKlick = { pfad: zielPfad, zeit: jetzt };

      // D4: ohne Rubik-Element auf der Seite ist der Quellseiten-Teil
      // gegenstandslos. Im Klickfall ist das Element zwar zwingend da — die
      // Pruefung steht hier trotzdem, weil sie zum Klickzeitpunkt sicher
      // auswertbar ist, waehrend sie beim Skriptstart am asynchron
      // nachgeladenen App-Block scheitern wuerde.
      if (!document.querySelector('rubik-combined-listings')) return;

      // Ohne Produktdaten koennen wir die Varianten-ID nicht in Optionswerte
      // uebersetzen. Nichts tun ist dann richtig.
      if (!produktDaten) return;

      var id = aktuelleVariantenId();
      if (!id) return;

      var variante = null;
      for (var i = 0; i < produktDaten.variants.length; i++) {
        if (String(produktDaten.variants[i].id) === id) {
          variante = produktDaten.variants[i];
          break;
        }
      }
      if (!variante || !variante.options) return;

      var namen = optionsNamen(produktDaten);
      var paare = [];
      for (var j = 0; j < namen.length; j++) {
        var name = namen[j];
        var wert = variante.options[j];
        if (!name || wert == null || String(wert).trim() === '') continue;
        paare.push({ name: name, value: wert });
      }
      if (!paare.length) return;

      var geschrieben = zettelSchreiben({
        pfad: zielPfad,
        optionen: paare,
        zeit: Date.now(),
        quelle: produktDaten.handle || null
      });

      if (geschrieben) log('Merkzettel geschrieben fuer', zielPfad, paare);
    } catch (fehler) {
      // E1: jeder Fehler fuehrt zu "nichts tun", niemals zu einem kaputten
      // Kaufprozess. Rubik navigiert davon unbeeindruckt weiter.
      log('Fehler beim Schreiben des Merkzettels', fehler);
    }
  }

  /* =========================================================================
   * Zielseite — Merkzettel anwenden
   * ======================================================================= */

  /**
   * Gueltigkeitspruefung. Alle Bedingungen muessen erfuellt sein.
   * Der Zettel ist zu diesem Zeitpunkt bereits geloescht (einmalige
   * Verwendung), hier wird nur noch ueber Anwenden oder Verwerfen entschieden.
   */
  function zettelGueltig(zettel) {
    if (!zettel) return false;

    // Zielpfad muss auf diese Seite zeigen.
    if (normPfad(zettel.pfad) !== normPfad(window.location.pathname)) {
      log('Merkzettel gilt fuer einen anderen Pfad', zettel.pfad);
      return false;
    }

    // Nicht aelter als 30 Sekunden.
    var alter = Date.now() - Number(zettel.zeit || 0);
    if (!(alter >= 0 && alter <= MAX_ALTER_MS)) {
      log('Merkzettel verwaist, Alter', alter);
      return false;
    }

    // Ein ausdruecklicher Deep-Link des Nutzers hat Vorrang.
    try {
      if (new URLSearchParams(window.location.search).has('variant')) {
        log('Eigener ?variant=-Parameter vorhanden, Merkzettel wird verworfen');
        return false;
      }
    } catch (fehler) {
      return false;
    }

    return true;
  }

  /**
   * Zuordnung nach C3: fuer jede Option des ZIELprodukts pruefen, ob der
   * Merkzettel denselben Optionsnamen kennt und ob das Ziel diesen Wert
   * ueberhaupt anbietet. Verglichen wird ueber den normalisierten Namen,
   * ausdruecklich NICHT ueber die Position — die Reihenfolge der Optionen
   * kann zwischen zwei Produkten derselben Rubik-Gruppe abweichen.
   *
   * Teiltreffer sind erwuenscht: "Beschlaege" wird uebernommen, "Lederbreite"
   * faellt weg, wenn das Ziel sie nicht kennt.
   *
   * Rueckgabe: Liste parallel zu den Zieloptionen, Eintrag null = unbestimmt.
   * Die uebernommenen Werte werden in der Schreibweise des ZIELS
   * zurueckgegeben, nicht in der des Merkzettels.
   */
  function ordneZu(produkt, zettel) {
    var namen = optionsNamen(produkt);
    var bestimmt = namen.map(function () {
      return null;
    });

    namen.forEach(function (name, index) {
      var eintrag = null;
      for (var i = 0; i < zettel.optionen.length; i++) {
        if (norm(zettel.optionen[i].name) === norm(name)) {
          eintrag = zettel.optionen[i];
          break;
        }
      }
      if (!eintrag) return;

      var werte = werteDerOption(produkt, index);
      for (var j = 0; j < werte.length; j++) {
        if (norm(werte[j]) === norm(eintrag.value)) {
          bestimmt[index] = werte[j];
          return;
        }
      }
    });

    return bestimmt;
  }

  /**
   * Zielvariante bestimmen: bestimmte Werte aus dem Merkzettel, unbestimmte
   * Optionen behalten den Wert der aktuell vorausgewaehlten Variante.
   * Ist die aktuelle Variante nicht auffindbar, bleiben unbestimmte Optionen
   * unbeschraenkt und es gewinnt die erste passende Variante.
   */
  function findeZielvariante(produkt, bestimmt, aktuelleId) {
    var aktuell = null;
    if (aktuelleId) {
      for (var i = 0; i < produkt.variants.length; i++) {
        if (String(produkt.variants[i].id) === String(aktuelleId)) {
          aktuell = produkt.variants[i];
          break;
        }
      }
    }

    var soll = bestimmt.map(function (wert, index) {
      if (wert !== null) return wert;
      if (aktuell && aktuell.options) return aktuell.options[index];
      return null;
    });

    for (var v = 0; v < produkt.variants.length; v++) {
      var variante = produkt.variants[v];
      var passt = true;
      for (var k = 0; k < soll.length; k++) {
        if (soll[k] === null) continue;
        if (norm((variante.options || [])[k]) !== norm(soll[k])) {
          passt = false;
          break;
        }
      }
      if (passt) return variante;
    }
    return null;
  }

  /**
   * C6 — Sicherung gegen Dawns Produktwechsel-Pfad.
   *
   * Jedes Optionsfeld traegt data-product-url aus value.product_url
   * (snippets/product-variant-options.liquid, Zeile 51). Ist der Wert gefuellt
   * und weicht er vom Pfad des aktuellen Produkts ab, behandelt Dawn den
   * Klick als Produktwechsel und ersetzt bei data-update-url="true" den
   * KOMPLETTEN <main>-Bereich (assets/product-info.js, Zeilen 98-106).
   * Dann darf nicht geklickt werden — in dem Fall auf die Umleitung
   * ausweichen.
   *
   * Im Browser gemessen sind diese Attribute bei den betroffenen Produkten
   * leer. Die Pruefung bleibt trotzdem, weil sich das mit der
   * Produktkonfiguration im Shop aendern kann, ohne dass jemand das Theme
   * anfasst.
   */
  function pruefeProduktwechselFalle(felder) {
    var produktInfo = document.querySelector('product-info');
    var eigenerPfad = normPfad(
      (produktInfo && produktInfo.dataset.url) || window.location.pathname
    );

    for (var i = 0; i < felder.length; i++) {
      var wert = normPfad(felder[i].dataset.productUrl || '');
      if (wert && wert !== eigenerPfad) {
        log('data-product-url weicht ab', wert, '- weiche auf Umleitung aus');
        return true;
      }
    }
    return false;
  }

  function umleiten(id) {
    var ziel = normPfad(window.location.pathname) + '?variant=' + encodeURIComponent(id);
    log('Umleitung auf', ziel);
    // replace statt assign: der Zurueck-Button soll keinen Zwischenschritt
    // bekommen, sonst landet der Kunde beim Zurueckgehen wieder hier und
    // wird erneut umgeleitet.
    window.location.replace(ziel);
  }

  /**
   * Auswahl im DOM setzen.
   *
   * Erst ALLE betroffenen Felder auf checked setzen, dann GENAU EIN
   * gebubbeltes change-Ereignis auf einem der geaenderten Felder ausloesen.
   *
   * Warum eines genuegt: Der Listener haengt am <variant-selects> selbst
   * (assets/global.js, Zeile 1069) und liest ueber den Getter
   * selectedOptionValues (Zeilen 1184-1188) den GESAMTEN Auswahlzustand aus,
   * nicht nur die geaenderte Gruppe. Mehrere Ereignisse wuerden mehrere
   * Abrufe der Section Rendering API starten, von denen Dawn alle bis auf den
   * letzten per AbortController abbricht — unnoetige Last plus AbortError in
   * der Konsole.
   *
   * Warum bubbles: true zwingend ist: siehe oben, der Listener sitzt nicht am
   * Feld. Warum das Ereignis aus dem echten DOM kommen muss: handleOptionValueChange
   * prueft als erstes this.contains(event.target) (assets/product-info.js,
   * Zeile 64) — ein am document gefeuertes Ereignis wird verworfen.
   *
   * Nebenwirkung, bewusst in Kauf genommen: updateSelectionMetadata
   * (assets/global.js, Zeilen 1148-1178) aktualisiert die Beschriftung
   * <span data-selected-value> nur fuer die Gruppe, in der das Ereignis
   * ausgeloest wurde. Die zweite Gruppe zeigt fuer die Dauer des Abrufs noch
   * den alten Wert im Legendentext. Das korrigiert sich von selbst, weil Dawn
   * danach das komplette <variant-selects> durch servergerendertes HTML
   * ersetzt (assets/product-info.js, Zeilen 169-174).
   */
  function auswahlSetzen(auswahl, produkt, bestimmt, zielVariante) {
    var felder = optionsFelder(auswahl);
    if (!felder.length) return false;

    var namen = optionsNamen(produkt);
    var zuSetzen = [];

    for (var i = 0; i < bestimmt.length; i++) {
      if (bestimmt[i] === null) continue;

      // Wert der ZIELvariante nehmen, nicht den aus dem Merkzettel: gleiche
      // Bedeutung, aber garantiert die Schreibweise, die im Markup steht.
      var wert = (zielVariante.options || [])[i];
      var feld = findeFeld(felder, namen[i], wert);

      // Ein bestimmter Wert ohne passendes Feld heisst: das Markup sieht
      // anders aus als erwartet. Dann lieber gar nichts tun, statt eine
      // halbe Auswahl zu setzen und eine andere Variante zu erzeugen als die
      // berechnete.
      if (!feld) {
        log('Kein Optionsfeld fuer', namen[i], wert);
        return false;
      }

      if (!feld.checked) zuSetzen.push(feld);
    }

    if (!zuSetzen.length) return false;

    if (pruefeProduktwechselFalle(zuSetzen)) {
      umleiten(zielVariante.id);
      return true;
    }

    zuSetzen.forEach(function (feld) {
      feld.checked = true;
    });

    zuSetzen[0].dispatchEvent(new Event('change', { bubbles: true }));
    log('Auswahl gesetzt, ein change-Ereignis ausgeloest', zuSetzen.length + ' Felder');
    return true;
  }

  function anwenden(produkt, zettel) {
    try {
      if (!produkt || !zettelGueltig(zettel)) return;

      var bestimmt = ordneZu(produkt, zettel);
      var hatBestimmte = bestimmt.some(function (w) {
        return w !== null;
      });
      if (!hatBestimmte) {
        log('Keine uebernehmbare Option');
        return;
      }

      var aktuelleId = aktuelleVariantenId();
      var ziel = findeZielvariante(produkt, bestimmt, aktuelleId);
      if (!ziel) {
        log('Keine passende Zielvariante');
        return;
      }

      if (aktuelleId && String(ziel.id) === String(aktuelleId)) {
        log('Zielvariante ist bereits vorausgewaehlt');
        return;
      }

      if (MODUS === 'umleitung') {
        umleiten(ziel.id);
        return;
      }

      var auswahl = variantenAuswahl();
      if (!auswahl) return;
      auswahlSetzen(auswahl, produkt, bestimmt, ziel);
    } catch (fehler) {
      log('Fehler beim Anwenden des Merkzettels', fehler);
    }
  }

  /* =========================================================================
   * Start
   * ======================================================================= */

  function start(zettel) {
    try {
      // D4: keine Produktseite.
      if (!document.querySelector('product-info')) return;

      // D4: Produkt hat nur eine Variante — Dawn rendert dann gar kein
      // <variant-selects> (snippets/product-variant-picker.liquid, Zeile 11).
      var auswahl = variantenAuswahl();
      if (!auswahl) return;

      // Dropdown-Darstellung: bewusster Abbruch.
      // Bei picker_type "dropdown" rendert das Theme <select> statt
      // Radio-Feldern (snippets/product-variant-picker.liquid, Zeilen 85-115).
      // Dort genuegt select.value nicht — der Getter selectedOptionValues
      // liest select option[selected], also das ATTRIBUT, nicht die Property
      // (assets/global.js, Zeilen 1184-1188). Das Attribut muesste zusaetzlich
      // umgehaengt werden. Der Fall kann heute nicht auftreten
      // (templates/product.json steht auf picker_type "button"); statt ihn
      // ungetestet mitzuschleppen, wird sauber abgebrochen.
      if (auswahl.querySelector('select')) {
        log('Dropdown-Darstellung erkannt, Skript bleibt untaetig');
        return;
      }

      // Quellseite: Listener global registrieren (E2), nicht an einem Element
      // im Produktbereich.
      //
      // window ist der VERIFIZIERTE Ort — Rubik feuert dort, nicht am
      // document. document zusaetzlich nur als Vorsorge fuer kuenftige
      // App-Versionen; gegen Doppelausfuehrung sichert die Sperre in
      // beiSwatchKlick.
      window.addEventListener('rcl_swatch_clicked', beiSwatchKlick);
      document.addEventListener('rcl_swatch_clicked', beiSwatchKlick);

      // Zielseite: Der Merkzettel wurde bereits beim Skriptstart gelesen und
      // geloescht. Angewendet wird, sobald die Produktdaten da sind.
      if (zettel) {
        produktLaeuft.then(function (produkt) {
          anwenden(produkt, zettel);
        });
      }
    } catch (fehler) {
      log('Start fehlgeschlagen', fehler);
    }
  }

  var produktLaeuft;
  var merkzettel = null;

  try {
    // Datenabruf sofort anstossen — er braucht kein DOM und ist der langsamste
    // Schritt.
    produktLaeuft = ladeProdukt();

    // Merkzettel ebenfalls sofort lesen und verwerfen (C2, einmalige
    // Verwendung). Braucht ebenfalls kein DOM.
    merkzettel = zettelLesenUndVerwerfen();
  } catch (fehler) {
    produktLaeuft = Promise.resolve(null);
  }

  // Das Snippet bindet die Datei mit defer ein, das DOM ist an dieser Stelle
  // also fertig geparst. Die Abfrage ist die Absicherung fuer den Fall, dass
  // die Einbindung spaeter einmal ohne defer erfolgt — der Block sitzt im
  // Template VOR dem variant_picker, ohne defer waere <variant-selects> dann
  // noch nicht vorhanden.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        start(merkzettel);
      },
      { once: true }
    );
  } else {
    start(merkzettel);
  }
})();
